import { api } from './api';

export type TenancyType = 'pupil' | 'full_member' | 'door_tenant' | 'associate' | 'staff';
export type MemberLifecycle = 'active' | 'former' | 'retired';
export type TransitionAction =
  | 'provision'
  | 'change_type'
  | 'leave'
  | 'retire'
  | 'reinstate'
  | 'cancel_upcoming';

export interface CurrentTenure {
  tenancyType: TenancyType;
  lifecycle: MemberLifecycle;
  effectiveFrom: string;
}

export interface MemberRow {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  memberType: string;
  status: string;
  tenure: CurrentTenure | null;
  hasUpcoming: boolean;
}

export interface TenureRecord {
  id: string;
  tenancyType: TenancyType;
  lifecycle: MemberLifecycle;
  effectiveFrom: string;
  effectiveTo: string | null;
  reason: string | null;
  recordedBy: { id: string; firstName: string; lastName: string } | null;
}

export interface MemberDetail {
  user: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    memberType: string;
    status: string;
  };
  current: TenureRecord | null;
  upcoming: TenureRecord[];
  history: TenureRecord[];
}

export const TENANCY_LABEL: Record<TenancyType, string> = {
  pupil: 'Pupil',
  full_member: 'Full Member',
  door_tenant: 'Door Tenant',
  associate: 'Associate',
  staff: 'Staff',
};

export const LIFECYCLE_LABEL: Record<MemberLifecycle, string> = {
  active: 'Active',
  former: 'Former',
  retired: 'Retired',
};

export async function fetchMembers(): Promise<MemberRow[]> {
  const res = await api.get('/members');
  return res.data.data as MemberRow[];
}

export async function fetchMember(userId: string): Promise<MemberDetail> {
  const res = await api.get(`/members/${userId}`);
  return res.data.data as MemberDetail;
}

export async function transitionMember(
  userId: string,
  input: {
    action: TransitionAction;
    tenancyType?: TenancyType;
    reason?: string;
    effectiveFrom?: string; // ISO datetime; future = scheduled
  },
): Promise<MemberDetail> {
  const res = await api.post(`/members/${userId}/transition`, input);
  return res.data.data as MemberDetail;
}
